<template>
  <div>
    <BushelBtn
      variant="primary"
      style="background-color: #2d3192"
      :style="btnStyles"
      :loading="loading"
      class="btn-sm w-100"
      button-id="'pay later button'"
      :tooltip-message="tooltipMessage"
      tooltip-placement="bottom"
      @click="handleClick"
    >
      <img
        v-if="version == 'large-white'"
        src="/img/vendor-logos/lendica/paylater_w_lendica_white.svg"
        alt="PayLater Financing with Lendica Partner"
        class="img-fluid"
      />
      <img
        v-else-if="version == 'small-white'"
        src="/img/vendor-logos/lendica/lendica_paylater_white.svg"
        alt="PayLater Financing with Lendica Partner"
        class="img-fluid"
      />
    </BushelBtn>
    <div v-if="showTotalsDisplay && orderTotal" class="mx-auto text-center mt-1" :class="totalTextClass">As low as ${{ totalDisplay }} / week</div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import * as api from "@/services/api";

export default {
  components: {},
  props: {
    location: { type: String, required: true },
    sellerCompanyName: { type: String, required: true },
    buyerCompanyName: { type: String, required: true },

    btnStyles: { type: String, default: "height: 34.8px" },
    version: { type: String, default: "small-white" },
    loading: { type: Boolean, default: false },
    tooltipMessage: { type: String, default: "Place your order and receive up to 12 week Net Terms financing through our partner Lendica." },
    totalTextClass: { type: String, default: "text-primary" },
    orderTotal: { type: Number },
    showTotalsDisplay: { type: Boolean, default: false },
  },
  emits: ["click"],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    totalDisplay() {
      if (!this.orderTotal) {
        return 0.0;
      }
      return ((+(this.orderTotal / 100) * 1.0775 * (1 + 0.05 * (20 / 52))) / 20).toFixed(2);
    },
  },
  mounted() {},
  methods: {
    handleClick() {
      this.logThisWasOpenedToSlack();
      this.$emit("click");
    },
    logThisWasOpenedToSlack() {
      const payload = {
        userName: this.user.name,
        location: this.location,
        sellerCompanyName: this.sellerCompanyName,
        invoiceNumber: "N/A",
        buyerCompanyName: this.buyerCompanyName,
      };
      api.post("paylater-button-clicked", payload);
    },
  },
};
</script>
